
import {defineComponent, PropType} from 'vue'
import {MenuScheduleNormalized} from "../defs";
import TextInput from "../../material-form/text-input.vue";
import MaterialButton from "../../material-form/MaterialButton.vue";
import {getDateAsUTC, isNormalizedScheduleActive} from "../../../helpers/menu-sections";
import ScheduleDisplay from "./ScheduleDisplay.vue";

export default defineComponent({
  name: "MenuSchedules",
  components: {ScheduleDisplay, MaterialButton, TextInput},
  props: {
    normalizedSchedules: {
      type: Array as PropType<MenuScheduleNormalized[]>,
      required: true,
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
      availabilityDateTime: '',
      availabilityDateTimeMessage: '',
      availabilityActiveSchedules: [] as number[],
    };
  },
  watch: {
    availabilityDateTime() {
      this.availabilityDateTimeMessage = '';
      this.availabilityActiveSchedules = [];
    },
  },
  computed: {
    handleIcon(): string {
      return this.isActive ? 'close' : 'schedule';
    },
    handleTitle(): string {
      return this.isActive ? 'Close Schedules' : 'Open Schedules';
    },
  },
  methods: {
    checkMenuAvailability() {
      if (this.availabilityDateTime.length) {
        if (!this.normalizedSchedules.length) {
          this.availabilityDateTimeMessage = '<span class="menu_schedules--message menu_schedules--message-success"><span class="material-icons">check</span>Menu is active for given date/time.</span>';
        } else {
          const menuTypesActive = [];
          const currentDate = new Date(this.availabilityDateTime);
          const currentDateTimeUtc = getDateAsUTC(currentDate).getTime();
          const currentDayOfWeek = currentDate.getDay();
          const currentTimeOfDay = currentDate.getHours() * 100 + currentDate.getMinutes();
          for (let i = 0, l = this.normalizedSchedules.length; i < l; i++) {
            if (isNormalizedScheduleActive(this.normalizedSchedules[i], currentDateTimeUtc, currentDayOfWeek, currentTimeOfDay)) {
              if (this.normalizedSchedules[i].schedule_is_textual && -1 === menuTypesActive.indexOf('Textual (Outlet Page)')) {
                menuTypesActive.push('Textual (Outlet Page)');
              }
              if (this.normalizedSchedules[i].schedule_is_visual && -1 === menuTypesActive.indexOf('Visual (iPad)')) {
                menuTypesActive.push('Visual (iPad)');
              }
              this.availabilityActiveSchedules.push(this.normalizedSchedules[i].schedule_id);
            }
          }
          if (!menuTypesActive.length) {
            this.availabilityDateTimeMessage = '<span class="menu_schedules--message menu_schedules--message-error"><span class="material-icons">check</span>Menu is not active for given date/time.</span>';
          } else {
            this.availabilityDateTimeMessage = '<span class="menu_schedules--message menu_schedules--message-success"><span class="material-icons">check</span>Menu is visible for given date/time for: ' + menuTypesActive.join(', ') + '</span>';
          }
        }
      }
    }
  },
})
